







import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  mounted(): void {
    console.log(this.$store.state);
  }
}
